import { memo } from 'react';

import Button from './Button';
import SocialButtonComponent from './SocialButton';

export default memo(Button);
export const SocialButton = memo(SocialButtonComponent);
